var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstrument1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bell",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 557.34 557.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2e1b16;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.81,455.37a24.63,24.63,0,0,0,9.69,15.57S227,496,231,518c0,0,0,13,17.5,19,0,0,31.5,7,44.5-12,0,0,11-31-10-51,0,0,2.29.43,5.64-6.28S238.81,455.37,238.81,455.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M421,214s9-13-52-50c0,0,1-8-8-19,0,0,20,4,18-38,10.89-9.12,18.34-17.07,21-36.09a44.14,44.14,0,0,0-6.09-29.79A40.43,40.43,0,0,0,371.47,24S316,9,318,85c0,0-26,32-4,46,0,0-18,2-22,11,0,0-34-4-67,3,0,0-52,181-137,197L73,368S210,492,421,475l3-30S354,373,421,214ZM336,90s-3-51,30-46c0,0,12.73,3.93,15,15,1.82,8.86-2,26-20,40A32.28,32.28,0,0,0,336,90Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrument1);
export default __webpack_public_path__ + "static/media/instrument-1.b687e67cfdd9053047467fa01222b1b9.svg";
export { ForwardRef as ReactComponent };